import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { englishDate, englishDateTime, ScrollToTop } from "../../algorithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import CreateNewNotification from "./addNotification";
import {
  searchAllNotifications,
  getDataNotificationForm,
} from "./../../API/store/actions/sharek";
import Titlebar from "../layout/titlebar";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import NotifIcationCard from "./notificationCard";
import { customStyle } from "../../algorithms/styleDirection";
import Paginate from "../layout/paginate";
import LoadingPopup from "./../layout/loadingPopup";

const NotifIcationIndex = () => {
  const [show, setShow] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [procAdded, setProcAdded] = useState(false);
  const [membersList, setMembersList] = useState([]);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [formMembers, setFormMembers] = useState([]);
  const userToken = useSelector((state) => state.login.userToken);
  const loginData = useSelector((state) => state.login);

  const onShow = () => {
    setShow(true);
  };
  const communityId = useSelector((state) => state.community.communityId?.id);
  const reload = useSelector((state) => state.reload.reload);
  const community = useSelector((state) => state.community.communityId);

  const renderModal = () => {
    return (
      <CreateNewNotification
        formMembers={formMembers}
        membersList={membersList}
        setMembersList={setMembersList}
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={show}
        onHide={() => setShow(false)}
      />
    );
  };

  const [notifications, setNotifications] = useState();

  useEffect(() => {
    resolver(
      searchAllNotifications,
      setNotifications,
      currentPage,
      20,
      {
        startDate: StartDate ? englishDateTime(StartDate) : null,
        endDate: EndDate ? englishDateTime(EndDate) : null,
        name: "",
        memberId: null,
      },
      userToken
    );

    if (loginData?.userData?.roles?.length > 1)
      resolver(getDataNotificationForm, setFormMembers, userToken);
    else if (
      loginData?.userData?.roles?.length == 1 &&
      loginData?.userData?.roles?.includes("Member")
    )
      return null;
    else resolver(getDataNotificationForm, setFormMembers, userToken);

    ScrollToTop();
  }, [currentPage, procAdded, communityId, StartDate, EndDate, reload]);

  if (notifications)
    return (
      <div className="d-flex flex-column w-100">
        {/* title */}
        <Titlebar
          title={"الإشعارات"}
          customImage={"/assets/images/icons/bell (1).png"}
        />
        <hr className="m-0" />

        <div className="d-lg-none col-12 d-flex justify-content-center align-items-center mt-4">
          {/* small screens button */}
          {community?.adminCommunity && (
            <CardWithTitleAndIcon
              containerStyle="d-flex justify-content-center align-items-center col-10 align-self-center"
              borderColor={"rgba(68, 68, 68, 0.25)"}
              height={90}
              width={230}
              onClick={() => {
                onShow();
              }}
              customImage={"/assets/images/icons/Group 8501.png"}
              imgHeight={60}
              imgWidth={60}
              containerImgHeight={60}
              containerImgWidth={60}
              cardTitle={"إضافة إشعار جديد"}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
            />
          )}
        </div>

        {/* Cards Listing Start */}
        <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
          <NotifIcationCard
            Notifications={notifications}
            communityId={communityId}
            userToken={userToken}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />

          {/* lg screens button */}
          {community?.adminCommunity && (
            <CardWithTitleAndIcon
              containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
                "createTaskButton"
              )}`}
              borderColor={"rgba(68, 68, 68, 0.25)"}
              height={180}
              width={180}
              onClick={() => {
                onShow();
              }}
              customImage={"/assets/images/icons/Group 8501.png"}
              imgHeight={70}
              imgWidth={70}
              containerImgHeight={80}
              containerImgWidth={120}
              cardTitle={"إضافة إشعار جديد"}
              boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
            />
          )}

          {formMembers?.data?.members?.length > 0 ? renderModal() : null}
        </div>
        {/* Cards Listing End */}
        {/* pagination */}
        {notifications?.count > 0 ? (
          <div className="my-3 d-flex justify-content-center col-lg-8">
            <Paginate
              pageCount={Math.ceil(notifications?.count / 20)}
              currentPage={currentPage}
              clearData={undefined}
              setCurrentPage={setCurrentPage}
            />
          </div>
        ) : (
          <div className="d-flex col-9 justify-content-center fa-2x mt-5">
            {" "}
            لا يوجد إشعارات{" "}
          </div>
        )}
        {/* end agination */}
      </div>
    );
  else return <LoadingPopup show={true} />;
};
export default NotifIcationIndex;
